import React, { useState, useEffect } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { SearchBar } from './styles';

interface Props {
  disabled?: string;
  show?: boolean;
  onSearch: (value: string) => void;
  onShowSearch?: (isSearch: boolean) => void;
  placeholder?: string;
  hasClose?: boolean;
  initialValue?: string;
  fullWidth?: boolean;
  className?: string;
}

const Search = ({
  onSearch,
  onShowSearch,
  placeholder,
  disabled,
  hasClose = true,
  initialValue,
  fullWidth,
  show = true,
  className,
}: Props) => {
  const [query, setQuery] = useState('');
  const { t } = useStoreTranslation();

  useEffect(() => {
    setQuery(initialValue ?? '');
    onSearch(initialValue ?? '');
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps
  // TODO: check dependencies or refactor

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setQuery(value);
    onSearch(value);
  };

  const switchShowSearch = (show: boolean) => {
    if (onShowSearch) onShowSearch(show);
  };

  const handleBlur = () => {
    if (!query) {
      onSearch('');
      switchShowSearch(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const ESC_KEY_CODE = 27;
    const escWasPressed = event.keyCode === ESC_KEY_CODE;

    if (escWasPressed) clearSearch();
  };

  const clearSearch = () => {
    setQuery('');
    onSearch('');
    switchShowSearch(false);
  };

  const handleClickSearchBar = () => {
    if (!disabled) switchShowSearch(true);
  };

  return (
    <>
      {show && (
        <SearchBar fullWidth={fullWidth} className={className || ''}>
          <SearchBar.Icon src={query ? '/corporate/images/search-bar/active.svg' : '/corporate/images/search-bar/disabled.svg'} />
          <SearchBar.InputContainer onClick={handleClickSearchBar}>
            <SearchBar.Input
              className={className || ''}
              disabled={disabled}
              onChange={handleSearch}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              value={query}
              placeholder={placeholder || t('searchBar.placeholder')}
            />
          </SearchBar.InputContainer>
          {hasClose && query.length > 0 && (
            <SearchBar.CloseSearch
              className={className || ''}
              onClick={clearSearch}
              src="/corporate/images/search-bar/input-clean.svg"
            />
          )}
        </SearchBar>
      )}
    </>
  );
};

export default Search;
